import React from 'react'
import { FileField, FileInput } from 'react-admin'
import { IInputProps } from 'src/types'

const CustomFileInput = ({
  property,
  name,
  ...rest
}: IInputProps<unknown>): JSX.Element => {
  return (
    <FileInput
      source={name}
      label={property.displayedName ?? name}
      {...rest}
    >
      <FileField
        source='src'
        title='title'
      />
    </FileInput>
  )
}

export default CustomFileInput
